import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

export interface NetworkPeer {
  ip: string;
  port: number;
  protocol_version: string;
  subversion: string;
  block_height: number;
  blocks_behind: number;
  city: string;
  country: string;
  lat: number;
  lng: number;
  last_seen_at: string;
  status: 'green' | 'yellow' | 'red';
}

export function useNetworkPeers() {
  const [peers, setPeers] = useState<NetworkPeer[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function fetchPeers() {
      const { data, error } = await supabase
        .from('network_peers')
        .select('*');

      if (!mounted) return;
      if (error) {
        console.error('Failed to fetch network peers:', error);
      } else {
        setPeers(data ?? []);
      }
      setLoading(false);
    }

    fetchPeers();

    const channel = supabase
      .channel('public:network_peers')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'network_peers' }, () => {
        if (mounted) fetchPeers();
      })
      .subscribe();

    return () => {
      mounted = false;
      supabase.removeChannel(channel);
    };
  }, []);

  return { peers, loading };
}
